import { graphJson } from "./client.ts";
import { LOGIN_SCOPES } from "../auth/config.ts";
import type { GraphRequestOptions } from "./client.ts";

/** The signed-in user. Covered by User.Read, so no module consent is needed. */
export interface GraphUser {
    id: string;
    displayName: string | null;
    userPrincipalName: string;
    mail: string | null;
}

type MeOptions = Partial<Pick<GraphRequestOptions, "signal" | "onRetry">>;

export async function getMe(options: MeOptions = {}): Promise<GraphUser> {
    return graphJson<GraphUser>("/me?$select=id,displayName,userPrincipalName,mail", {
        scopes: LOGIN_SCOPES,
        service: "outlook",
        ...options
    });
}
